<template>

<com-section :title="title" :completed="completed" :active="active" v-on:next="$emit('next')" v-on:back="$emit('back')">

	<div class="text" v-html="parsedText" v-on:click="onTextClick"></div>

</com-section>

</template>

<script>

import comSection from './Section'
import sectionLinks from '@/mixin/sectionlinks'

// Thumbnail previews shown inline next to a [image=key] media link, so the
// graphic is visible without having to open the modal.
var MEDIA_THUMBS = {
	bone: require('@/assets/aid/health/inside2.gif'),
	spine: require('@/assets/aid/health/spine.gif'),
	population: require('@/assets/aid/health/rate.png'),
	skeleton: require('@/assets/aid/risk/skeleton.svg')
}

export default {

	props: ['title', 'text', 'completed', 'active'],

	mixins: [sectionLinks],

	components: {
		'com-section': comSection
	},

	computed: {

		parsedText: function() {

			if (!this.text) return ''

			var html = this.text.replace(/\[image=([^\]]+)\](.*?)\[\/image\]/g, function(match, key, label) {
				return '<a href="#" class="media-link" data-media="' + key + '"><i class="fa-solid fa-up-right-from-square"></i> ' + label + '</a>'
			})

			html = this.parseSectionLinks(html)

			// Place each thumbnail at the end of the block (bullet/paragraph)
			// that houses its link, so it sits under that text rather than
			// inline mid-sentence or after the whole list.
			if (typeof document !== 'undefined' && html.indexOf('media-link') !== -1) {

				var container = document.createElement('div')
				container.innerHTML = html

				Array.prototype.forEach.call(container.querySelectorAll('.media-link'), function(link) {

					var key = link.getAttribute('data-media')
					if (!MEDIA_THUMBS[key]) return

					var host = link.closest('li') || link.closest('p') || container

					var img = document.createElement('img')
					img.className = 'media-thumb'
					img.setAttribute('data-media', key)
					img.setAttribute('alt', '')
					img.src = MEDIA_THUMBS[key]

					host.appendChild(img)

				})

				html = container.innerHTML

			}

			return html

		}

	},

	methods: {

		onTextClick: function(e) {

			if (this.onSectionLinkClick(e)) return

			var target = e.target.closest('.media-link')

			if (target) {
				e.preventDefault()
				this.$emit('media', target.getAttribute('data-media'))
				return
			}

			var thumb = e.target.closest('.media-thumb')

			if (thumb) {
				e.preventDefault()
				this.$emit('media', thumb.getAttribute('data-media'))
				return
			}

			var img = e.target.closest('img')

			if (img) {
				e.preventDefault()
				this.$emit('image', img.getAttribute('src'))
			}

		}

	}

}

</script>

<style scoped>

.text {
	font-size: 18px;
	color: #343434;
	line-height: 28px;
	font-weight: 300;
}

.is-mobile .text {
	font-size: 14px;
	line-height: 22px;
}

.text >>> p { margin-bottom: 12px; }
.text >>> ul { padding-left: 20px; margin-bottom: 12px; }
.text >>> li { margin-bottom: 4px; }

.text >>> img {
	cursor: pointer;
	transition: opacity 300ms ease-in-out;
}

.text >>> img:hover {
	opacity: 0.8;
}

.text >>> .media-link {
	display: inline;
	color: #343434;
	font-weight: 600;
	text-decoration: underline;
	text-decoration-color: var(--aid-color);
	text-underline-offset: 3px;
	text-decoration-thickness: 2px;
	cursor: pointer;
	transition: color 300ms ease-in-out;
}

.text >>> .media-link:hover {
	color: var(--aid-color);
}

.text >>> .media-link i {
	font-size: 11px;
	margin-right: 3px;
}

.text >>> .media-thumb {
	display: block;
	max-width: 220px;
	max-height: 150px;
	margin-top: 12px;
	margin-bottom: 12px;
	border-radius: 12px;
	border: 2px solid var(--aid-color);
	cursor: pointer;
	transition: opacity 300ms ease-in-out;
}

.text >>> .media-thumb:hover {
	opacity: 0.85;
}

.is-mobile .text >>> .media-thumb {
	max-width: 160px;
	max-height: 110px;
}

</style>
